import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import EditEntityV2Container from 'containers/forms/EditEntityV2Container';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import PageTitle from 'hoc/PageTitle';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const EditEntityPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/entities">&lt; Entities</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>

        <EditEntityV2Container {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Edit Entity' }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS] }),
)(EditEntityPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/entities/EditEntity.js